import * as React from "react";
import { forwardRef } from "react";
const SvgArrowPointLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: "2.5em", height: "2.5em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M26 32L14 20L26 8", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgArrowPointLeft);
export default ForwardRef;
